module.exports = __webpack_public_path__ + "static/media/product-placeholder.6fd223a5.png";